import {SearchSvg} from "@/app/components/icons/SearchSvg";
import {AppInput} from "@/app/components/common/app-input/AppInput";
import React, {HTMLAttributes} from "react";
import {cn} from "@/lib/utils";
import {useTranslations} from "next-intl";

interface IProps extends HTMLAttributes<HTMLDivElement> {
    autoComplete?: string;
    value?: string;
    onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
    inputClassName?: string;
    readOnly?: boolean;
}


export default function SearchInput({className, value, onChange, autoComplete = 'on', inputClassName, readOnly, ...props}: IProps) {
    const t = useTranslations();
    return (
        <div
            className={cn('bg-gray rounded-[12px] flex items-center gap-[10px] px-[10px] text-light-gray', className)} {...props}>
            <div>
                <SearchSvg/>
            </div>
            <AppInput readOnly={readOnly} value={value} onChange={onChange} autoComplete={autoComplete} placeholder={t("SearchInput.placeholder")}
                      name={'search'}
                      className={cn('bg-transparent rounded-[12px] border-0 px-0', inputClassName)}/>
        </div>
    )
}
